const ConsumerDept = () =>
  import('@/views/main/consumer/consumerDept/ConsumerDept.vue')
export default {
  path: '/main/consumer/consumerDept',
  name: 'ConsumerDept',
  component: ConsumerDept,
  children: []
}
